import addToCartActionTypes from '../actionTypes/AddToCartActionTypes';

const initialState = {
    cartSuccess: [],
    cartFailure: [],
    totalAddToCartRequestCount: 0,
    otherErrors: [],
};

function RevieveAddToCartReducer(state = initialState, action) {
    switch (action.type) {
        case addToCartActionTypes.REVIEVE_ADDTOCART_RESPONSE:
            return {
                cartSuccess: action.cartSuccess,
                cartFailure: action.cartFailure,
                totalAddToCartRequestCount: action.totalAddToCartRequestCount,
            };

        case addToCartActionTypes.REVIEVE_ADDTOCART_API_ERROR:
            return {
                cartSuccess: [],
                cartFailure: [],
                totalAddToCartRequestCount: action.totalAddToCartRequestCount,
                otherErrors: action.otherErrors,
            };

        case addToCartActionTypes.REVIEVE_ADDTOCART_RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
}

RevieveAddToCartReducer.reducerName = 'revieveAddToCart';
export default RevieveAddToCartReducer;
